import React from 'react';

import { useIntl } from 'ha/i18n';
import {
  RoomsFilterValue,
  RoomsValue,
  RoomsFilterCount,
} from 'ha/types/SearchFilters';

import { CommonCheckboxFilter } from './CommonCheckboxFilter';
import { CommonCheckboxTitleWithCount } from './CommonCheckboxTitleWithCount';

interface Props {
  value: RoomsFilterValue;
  onChange: (value: RoomsFilterValue) => void;
  count?: RoomsFilterCount;
}

const RoomFilter: React.FC<Props> = ({ value, onChange, count }) => {
  const { T } = useIntl();

  const handleChange = React.useCallback(
    (newValue: RoomsValue[]) => {
      onChange({ bedroomCount: newValue });
    },
    [onChange],
  );

  const bedroomCount = React.useMemo<string[]>(() => {
    return value.bedroomCount.map((bedroom: number | string) =>
      bedroom.toString(),
    );
  }, [value.bedroomCount]);

  return (
    <CommonCheckboxFilter
      options={[
        {
          value: RoomsValue.ONE,
          title: (
            <CommonCheckboxTitleWithCount
              title={`1 ${T('bedroom')}`}
              count={count?.one}
            />
          ),
          testLocator: 'RoomsFilter One',
        },
        {
          value: RoomsValue.TWO,
          title: (
            <CommonCheckboxTitleWithCount
              title={`2 ${T('bedroom')}`}
              count={count?.two}
            />
          ),
          testLocator: 'RoomsFilter Two',
        },
        {
          value: RoomsValue.THREE,
          title: (
            <CommonCheckboxTitleWithCount
              title={`3 ${T('bedroom')}`}
              count={count?.three}
            />
          ),
          testLocator: 'RoomsFilter Three',
        },
        {
          value: RoomsValue.FOUR_AND_MORE,
          title: (
            <CommonCheckboxTitleWithCount
              title={`4+ ${T('bedroom')}`}
              count={count?.overFour}
            />
          ),
          testLocator: 'RoomsFilter Four',
        },
      ]}
      value={bedroomCount}
      onChange={handleChange}
    />
  );
};

export { RoomFilter };
